export default __webpack_public_path__ + "static/main-graphic-1bde4af602a29d56702cdd0ed6333e91.png";